import { AuthGuard } from '@/auth/guard/auth.guard';
import { LoginResponse, RouteDefinition } from '@/auth/interface/auth.interface';
import { routesDefinition } from '@/auth/routes/auth.routes';
import { AuthService } from '@/auth/service/auth.service';
import { ApprovalsService } from '@/services/approvals/approvals.service';
import { StoreState } from '@/store';
import { State } from '@/store/login/reducer';
import { getCurrentUserData } from '@/store/login/selectors';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { getEnvironment } from 'src/environments/dinamicEnv';
import { TaskDetailAndTotalTasksService } from '../../services/taskDetailAndTotalTasks/task-detail-and-total-tasks.service';

const environment = getEnvironment();

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
})
export class NavbarComponent {

  @ViewChild('card', { static: false }) cardRef: ElementRef;

  mobileMenuShow = false;
  mobileShowOptions: Array<boolean> = [];

  routesDefinition: any[] = [];

  show = false;

  userData?: State;
  sanitizedBase64Image: SafeUrl = '';

  lastUrl: string = '';
  currentUrl: string = '';
  fullName: string = '';
  initialsUser: string = '';

  navigationWithoutApprovalRole: number = 0;

  cardVisibility: boolean = false;

  constructor(
    private totalTaskService: TaskDetailAndTotalTasksService,
    private store: Store<StoreState>,
    private authGuard: AuthGuard,
    private auth: AuthService,
    private router: Router,
    private approvalService: ApprovalsService,
    private domSanitizer: DomSanitizer,
    private ref: ElementRef,
  ) {
    this.cardRef = this.ref;

    getCurrentUserData(this.store).subscribe({
      next: (userData) => {
        this.userData = userData;
        this.fullName = userData.fullName;
        this.sanitizedBase64Image = this.domSanitizer.bypassSecurityTrustUrl(userData.photo);

        const name = this.fullName.split(' ');
        this.initialsUser = name[0].substring(0, 1).toUpperCase();
        if (name.length > 1) {
          this.initialsUser += name[name.length - 2].substring(0, 1).toUpperCase();
        }

        this.refreshRoutes();

        this.checkApprovalPrivileges(userData).subscribe({
          next: () => {
            this.refreshRoutes();
          },
        });

        this.getTotatlyTasks();

        this.router.events.subscribe({
          next: (val: any) => {
            if (val.url) {
              const [website, ...url] = window.location.href.split('//')[1].split('/');
              this.currentUrl = ['', ...url].join('/');
              if (this.lastUrl !== val.url) {
                this.lastUrl = val.url;
                /*
                  If the user have a requirement for approval
                  add privilege to do it if the user haven't
                */
                this.checkApprovalPrivileges(userData);
                this.getTotatlyTasks();
              }
            }
          },
        });

      },
    });

  }

  checkApprovalPrivileges(userData: LoginResponse): Observable<any> {
    const requirementList$ = this.approvalService.getTotalRequestApprovalCount(userData.mdmid);

    requirementList$.subscribe({
      next: (requirementsForApprovalCount) => {
        if (requirementsForApprovalCount > 0) {
          this.auth.addPrivilegeLocally('APPROVAL_CO');
          this.auth.addPrivilegeLocally('APPROVAL LIST');
          this.navigationWithoutApprovalRole = 0;
        }
        else {
          if (this.navigationWithoutApprovalRole === 1) {
            this.auth.removePrivilegeLocally('APPROVAL_CO');
            this.auth.removePrivilegeLocally('APPROVAL LIST');
          }
          this.navigationWithoutApprovalRole++;
        }
        if (this.navigationWithoutApprovalRole <= 2) {
          this.refreshRoutes();
        }
      },
    });

    return requirementList$;
  }

  refreshRoutes() {
    const routesDefinitionFiltered = routesDefinition.filter((definition) => definition.routes.some((route) => this.havePrivileges(route)));

    const routesDefinitionWithShow = routesDefinition.map((definition) => ({
      ...definition,
      show: routesDefinitionFiltered.some((filteredDefintion) => filteredDefintion.title === definition.title),
    }));

    this.routesDefinition = routesDefinitionWithShow.map((definition) => ({
      ...definition,
      routes: definition.routes.filter((route) => !route.hidden),
    }));
  }

  hoverIndex: number = -1;

  onHoverContainer() {
    this.show = false;
  }

  onHoverChild(index: number) {
    this.hoverIndex = index;
    this.show = true;
  }

  onBlurContainer() {
    this.show = false;
  }

  // --------------Total Task--------------
  totalTaskPending: number = 0

  getTotatlyTasks() {
    if (this.userData) {
      this.totalTaskService.getTotalTaskPendingCount(this.userData.mdmid)
        .subscribe({
          next: (res: any) => {
            this.totalTaskPending = res;
          },
        });
    }
  }

  mobileToogleMenu(open: boolean = !this.mobileMenuShow) {
    this.mobileMenuShow = open;
    for (let index = 0; index < this.mobileShowOptions.length; index++) {
      this.mobileShowOptions[index] = false;
      this.show = false;
    }

  }
  onClickOptionMobile(index: number) {
    this.mobileShowOptions[index] = this.mobileShowOptions[index] || false;
    this.mobileShowOptions[index] = !this.mobileShowOptions[index];
  }

  havePrivileges(routesDefinitionToEvaluate: RouteDefinition): boolean {
    return this.authGuard.havePrivileges(routesDefinitionToEvaluate);
  }

  showCard() {
    const node = this.cardRef.nativeElement as HTMLDivElement;
    node.focus();
    this.cardVisibility = true;
  }

  onFocus() {
  }

  hideCard() {
    this.cardRef.nativeElement.blur();
    this.cardVisibility = false;
  }

  goToMyProfile() {
    if (!window.location.href.includes('/verification')) {
      this.router.navigateByUrl('/verification/licenses');
    }
    setTimeout(() => {
      this.hideCard();
    }, 0);
  }

  onLogout() {
    localStorage.removeItem('session');
    if ('disableAzureLogin' in environment) {
      // eslint-disable-next-line dot-notation
      if (environment['disableAzureLogin']) {
        this.router.navigateByUrl('/login');
        return;
      }
    }

    this.auth.logout();
    // window.location.href = 'https://login.microsoftonline.com/common/oauth2/logout';
    // this.router.('https://login.microsoftonline.com/common/oauth2/logout');
    // this.authService.logoutRedirect({
    //   // If in iframe, dont perform redirect to AAD
    //   // onRedirectNavigate: () => !BrowserUtils.isInIframe(),
    // });
  }
}
